module.exports = __webpack_public_path__ + "e0d99929412609af12a166e2a70d6f7c.svg";